<template>
  <div>
    <v-row>
      <v-col style="max-width: 280px; padding: 0; padding-left: 15px; padding-right: 15px">
        <date-picker :value="dateRange" @range-changed="setDateRange"/>
      </v-col>
    </v-row>
    <v-row v-if="true">
      <v-col v-if="datesChanged">
          <v-btn disabled small color="success" width="100%">
          Search
          <v-icon style="padding-left: 15px" small>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
      <v-col v-else>
        <v-btn type="submit" @click="resetAllFilters" small color="success" width="100%">
          Search
          <v-icon style="padding-left: 15px" small>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="true">
      <v-col
        style="max-width: 243px;
          padding: 8px 15px 0;"
        v-if="true">
        <v-select
          dense
          hide-details
          outlined
          v-model="defaultCountry"
          :items="countriesFormatted"
          label="Country"
          @change="defaultState = null"
          @input="(country) => setCountryOf(country)">
          <template v-slot:item="{ item }">
            <span style="margin-right: 5px; margin-top: 3px">
              <country-flag :country="item.value" size="small"/>
            </span>
            <span>{{ item.text }}</span>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row v-if="true">
      <v-col
        style="max-width: 243px;
          padding: 8px 15px 0;"
        v-if="true">
        <v-select
          hide-details
          dense
          v-model="defaultState"
          outlined
          :items="states"
          label="State"
          @input="(state) => setStateOf(state)"></v-select>
      </v-col>
    </v-row>
    <v-row v-if="true">
      <v-col
        style="max-width: 243px;
          padding: 8px 15px 0;"
        v-if="true">
        <v-select
          hide-details
          dense
          v-model="defaultCode"
          outlined
          :items="codes"
          label="Meeting Type"
          @input="(code) => setCodeOf(code)"></v-select>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
// import iso31661 from 'iso-3166';
import countries from 'i18n-iso-countries'
// import Codes from '../Codes/Codes.vue'
import { DatePicker } from '..'

export default {
  name: 'SearchFilter',
  data () {
    return {
      defaultCountry: {
        value: '',
        text: 'All'
      },
      defaultState: {
        value: '',
        text: 'All'
      },
      defaultCode: {
        value: '',
        text: 'All'
      }
    }
  },
  props: {
    resetFilters: Boolean,
    viewType: String
  },
  components: { DatePicker },
  computed: {
    ...mapGetters(['getSelectedCodes']),
    ...mapState(['dateFrom', 'dateTo', 'countryRaces', 'secondRaces', 'countryOf', 'races', 'stateOf', 'stateValues', 'staleDateRange']),
    datesChanged () {
      return (this.dateRange.start === this.staleDateRange.start && this.dateRange.end === this.staleDateRange.end)
    },
    countriesFormatted () {
      // eslint-disable-next-line global-require
      countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
      const countrySorted = this.countryRaces.filter(c => !!c.trackCountry)
      const countryList = countrySorted.map((c) => ({
        value: countries.alpha3ToAlpha2(`${c.trackCountry}`),
        text: countries.getName(`${c.trackCountry}`, 'en')
      }))
      const b = {
        value: '',
        text: 'All'
      }
      let ausCountry
      let nzCountry
      countryList.forEach((a) => {
        if (a.value === 'NZ') {
          nzCountry = a
        }
        if (a.value === 'AU') {
          ausCountry = a
        }
      })
      countryList.sort((a, b) => a.text.localeCompare(b.text))
      if (nzCountry) {
        countryList.unshift(nzCountry)
      }
      if (ausCountry) {
        countryList.unshift(ausCountry)
      }
      countryList.unshift(b)
      return [...new Set(countryList)]
    },
    states () {
      const races = this.countryRaces.map((c) => ({
        state: c.trackState
      }))
      const statesF = this.stateValues.map((c) => ((races.some((e) => e.state === c.isoCode)) ? { value: c.isoCode, text: c.name } : undefined)).filter((f) => f)
      const b = {
        value: '',
        text: 'All'
      }
      statesF.unshift(b)
      return statesF
    },
    codes () {
      return [
        {
          value: '',
          text: 'All'
        },
        {
          value: 'THOROUGHBRED',
          text: 'Thoroughbred'
        },
        {
          value: 'HARNESS',
          text: 'Harness'
        },
        {
          value: 'GREYHOUND',
          text: 'Greyhound'
        }
      ]
    },
    dateRange () {
      return {
        start: this.dateFrom,
        end: this.dateTo
      }
    }
  },
  watch: {
    defaultCountry () {
      this.fetchMeetings()
      this.fetchBookieBetsCountry()
      this.fetchBookieRace()
    },
    defaultState () {
      this.fetchMeetings()
      this.fetchBookieBetsCountry()
      this.fetchBookieRace()
    },
    defaultCode () {
      this.fetchMeetings()
      this.fetchBookieBetsCountry()
      this.fetchBookieRace()
    },
    resetFilters () {
      if (this.resetFilters === true) {
        this.defaultCountry = null
        this.defaultState = null
        this.defaultCode = null
      }
    }
  },
  methods: {
    ...mapActions(['search', 'searchOverView', 'setDates', 'fetchMeetings', 'fetchBookieRace', 'fetchBookieBetsCountry', 'setCountryOf', 'fetchAllRaces', 'setStateOf', 'updateRaceFilters', 'setCodeOf', 'setStaleDateRange']),
    setDateRange (r) {
      this.setDates(r)
    },
    onCodesClick (codes) {
      this.updateRaceFilters(codes)
    },
    resetAllFilters () {
      if (this.viewType === 'overView') {
        this.searchOverView()
      } else {
        this.search()
      }
      this.setStaleDateRange(this.dateRange)
      // if (this.defaultCountry.value !== '') {
      //   this.defaultCountry = ''
      // }
      // if (this.defaultState.value !== '') {
      //   this.defaultState = ''
      // }
      // if (this.defaultCode.value !== '') {
      //   this.defaultCode = ''
      // }
    }
  }
}
</script>

<style scoped>
</style>
